import { SvgIcon } from "@mui/material";
import { ReactComponent as EyeIcon } from "./../Icons/Eye.svg";
import { ReactComponent as ClockIcon } from "./../Icons/Clock.svg";
import { ReactComponent as SuggestedReviewersIcon } from "./../Icons/SuggestedReviewers.svg"
import { ReactComponent as SmallEyeIcon } from "./../Icons/SmallEye.svg"
import { ReactComponent as ProposalDetailsIcon } from "./../Icons/ProposalDetails.svg"
import { ReactComponent as DetailedEvaluationIcon } from "./../Icons/DetailedEvaluation.svg"
import { ReactComponent as GradingIcon } from "./../Icons/Grading.svg"
import { ReactComponent as FinalRecommendationIcon } from "./../Icons/FinalRecommendation.svg"


export const Eye = (props) => (
  <SvgIcon {...props} component={EyeIcon} style={{width:"100%", height:30}} viewBox="0 0 41 25"/>
);
export const Clock = (props) => (
  <SvgIcon {...props} component={ClockIcon}/>
);
export const SuggestedReviewers = (props) => (
  <SvgIcon {...props} component={SuggestedReviewersIcon} viewBox="0 0 17 17" />
);
export const SmallEye = (props) => (
  <SvgIcon {...props} component={SmallEyeIcon} viewBox="0 0 17 17" />
);
export const Details = (props) => (
  <SvgIcon {...props} component={ProposalDetailsIcon} viewBox="0 0 25 25"/>
);
export const EvaluationDetails = (props) => (
  <SvgIcon {...props} component={DetailedEvaluationIcon} viewBox="0 0 28 28" />
);
export const Grading = (props) => (
  <SvgIcon {...props} component={GradingIcon} viewBox="0 0 25 25"/>
);
export const RecommendationIcon = (props) => (
  <SvgIcon {...props} component={FinalRecommendationIcon} viewBox="0 0 27 27"/>
);

